import { AlertTriangle } from 'lucide-react'
import { Badge } from '@/components/ui'

/**
 * Small badge flagging a bogus event date (e.g. epoch 1970) so admins and
 * users notice the date needs fixing.
 */
export default function DateWarning({
  compact = false,
}: {
  compact?: boolean
}) {
  return (
    <Badge tone="danger" iconLeft={<AlertTriangle size={13} />}>
      {compact ? 'Date ?' : 'Date à vérifier'}
    </Badge>
  )
}
